import React from "react";

const GREEN = "#10B981";

// Suppev wordmark as inline SVG (no external image => zero credits).
// Capsule with "S" + clean "uppev" text. No magnifying glass.
export const Logo = ({ size = 40, className = "" }) => (
  <svg
    height={size}
    viewBox="0 0 212 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Suppev logo"
    data-testid="nav-brand-logo"
    className={className}
    style={{ width: "auto", display: "block" }}
  >
    {/* Capsule holding the S */}
    <rect x="2" y="2" width="50" height="70" rx="25" fill={GREEN} />
    <circle cx="27" cy="37" r="18" fill="#ffffff" />
    <text
      x="27"
      y="38"
      textAnchor="middle"
      dominantBaseline="central"
      fontFamily="'Plus Jakarta Sans', sans-serif"
      fontWeight="800"
      fontSize="35"
      fill={GREEN}
    >
      S
    </text>

    {/* uppev */}
    <text
      x="60"
      y="56"
      fontFamily="'Plus Jakarta Sans', sans-serif"
      fontWeight="800"
      fontSize="48"
      letterSpacing="-1"
      fill={GREEN}
    >
      uppev
    </text>
  </svg>
);

export default Logo;
